var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartaCor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_1587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.0002 8.33337H5.00019C4.07972 8.33337 3.33353 9.07957 3.33353 10V30C3.33353 30.9205 4.07972 31.6667 5.00019 31.6667H35.0002C35.9207 31.6667 36.6669 30.9205 36.6669 30V10C36.6669 9.07957 35.9207 8.33337 35.0002 8.33337Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6669 31.6667H3.33353L17.7703 18.6737C18.3824 18.1228 19.1767 17.818 20.0002 17.818C20.8237 17.818 21.618 18.1228 22.2301 18.6737L36.6669 31.6667Z",
    fill: "#FFE600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33353 8.33337H36.6669L22.2301 21.3265C21.618 21.8774 20.8237 22.1822 20.0002 22.1822C19.1767 22.1822 18.3824 21.8774 17.7703 21.3265L3.33353 8.33337Z",
    fill: "#FFC20E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_1587"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartaCor);
export default __webpack_public_path__ + "static/media/carta-cor.d82f99c5a7cfe48419429b99b2611865.svg";
export { ForwardRef as ReactComponent };